import { render } from "./gdpr-block.vue?vue&type=template&id=31e558a8"
import script from "./gdpr-block.vue?vue&type=script&lang=js"
export * from "./gdpr-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__